import { createRoot } from "react-dom/client";
import "./index.css";
import { GoogleOAuthProvider } from "@react-oauth/google";
import usePollRefreshToken from "@roman/shared/hooks/auth/usePollRefreshToken";
import { useEffect } from "react";
import ReactGA from "react-ga4";
import TagManager from "react-gtm-module";
import { HelmetProvider } from "react-helmet-async";
import { createWebEnv } from "./config/webEnv";
import { webEnv } from "./config/webEnv";
import Root from "./routes";

const GA_MEASUREMENT_ID = "G-KQR7E0ZMCK";

const AppInitializer = ({ children }: { children: React.ReactNode }) => {
  usePollRefreshToken();
  useEffect(() => {
    if (webEnv.DEV) return;
    ReactGA.initialize(GA_MEASUREMENT_ID, {
      gtagOptions: {
        send_page_view: false,
      },
    });
  }, []);

  return <>{children}</>;
};

const tagManagerArgs = {
  gtmId: GA_MEASUREMENT_ID,
};

TagManager.initialize(tagManagerArgs);

const container = document.querySelector("#root");

if (container) {
  const env = createWebEnv();
  const root = createRoot(container);
  root.render(
    <HelmetProvider>
      <GoogleOAuthProvider clientId={env.GOOGLE_CLIENT_ID}>
        <AppInitializer>
          <Root />
        </AppInitializer>
      </GoogleOAuthProvider>
    </HelmetProvider>,
  );
} else {
  throw new Error("ルートコンテナが見つかりません");
}
